module.exports = __webpack_public_path__ + "img/tick.b5a65a1c.svg";